
export default {
  nav: {
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    references: 'References',
    contact: 'Contact'
  },
  hero: {
    title: {
      line1: 'Modern Irrigation',
      line2: 'Solutions'
    },
    subtitle: 'Professional irrigation systems that increase your agricultural productivity',
    cta: {
      about: 'About Us',
      contact: 'Get in Touch'
    },
    slides: {
      slide1: {
        title: 'Modern Irrigation Solutions',
        subtitle: 'Professional irrigation systems that increase your agricultural productivity'
      },
      slide2: {
        title: 'Smart Irrigation Technology',
        subtitle: 'Automatic irrigation systems working at sunset'
      },
      slide3: {
        title: 'Sustainable Agriculture',
        subtitle: 'Environmentally friendly and efficient irrigation solutions'
      },
      slide4: {
        title: 'Greenhouse Irrigation Systems',
        subtitle: 'Special irrigation technologies for controlled environment agriculture'
      }
    }
  },
  features: {
    title: 'Why Choose Us?',
    subtitle: 'We maximize your agricultural productivity with modern technology and our expert team.',
    efficiency: {
      title: 'High Efficiency',
      desc: 'Up to 40% efficiency increase with modern drip irrigation systems that save water'
    },
    sustainable: {
      title: 'Sustainable Solutions',
      desc: 'Agricultural production while protecting nature with environmentally friendly technologies'
    },
    reliable: {
      title: 'Reliable Service',
      desc: 'Uninterrupted service with 25 years of experience and 24/7 technical support'
    }
  },
  values: {
    title: 'Our Values',
    subtitle: 'We continue to be a leader in the industry with our customer satisfaction-oriented approach.',
    trust: {
      title: 'Trust',
      desc: 'Transparent business processes and quality service approach'
    },
    quality: {
      title: 'Quality',
      desc: 'Use of international standard equipment and materials'
    },
    satisfaction: {
      title: 'Satisfaction',
      desc: 'Customer-oriented solutions and continuous support'
    },
    nature: {
      title: 'Nature Friendly',
      desc: 'Environmentally respectful and sustainable technologies'
    }
  },
  stats: {
    projects: 'Completed Projects',
    experience: 'Years Experience',
    customers: 'Happy Customers',
    support: 'Technical Support'
  },
  gallery: {
    title: 'Our Projects',
    subtitle: 'Examples from our successful irrigation projects',
    installation: 'System Installation',
    'installation.desc': 'Fast and safe installation with our professional team',
    active: 'Active Systems',
    'active.desc': 'Images from our working irrigation systems',
    planning: 'Project Planning',
    'planning.desc': 'Detailed engineering studies and planning'
  },
  cta: {
    title: 'Let\'s Bring Your Project to Life',
    subtitle: 'Contact our expert team, let\'s develop a custom irrigation solution for you.',
    contact: 'Get in Touch',
    services: 'Our Services'
  },
  language: {
    label: 'Language',
    switch: 'Türkçe'
  },
  social: {
    followUs: 'Follow Us',
    facebook: 'Facebook',
    twitter: 'Twitter',
    linkedin: 'LinkedIn',
    instagram: 'Instagram'
  },
  common: {
    phone: '+90 553 414 52 63',
    email: 'info@guventar.com',
    address: 'Cumalı Mh. Antalya Cd. No:9, Serik/Antalya',
    workingHours: 'Working Hours',
    followUs: 'Follow Us'
  },
  about: {
    hero: {
      title: 'About Us',
      subtitle: 'Your reliable solution partner in agricultural irrigation systems'
    },
    story: {
      title: 'Our Company Story',
      content1: 'GüvenTar Systems is an innovative engineering company established in 2005 with the aim of efficient water management and sustainable production in agriculture. Since our establishment, we have successfully completed hundreds of projects in various regions of Turkey.',
      content2: 'With our experience of over 25 years, we provide services in a wide range from drip irrigation systems to modern automation solutions. We aim to increase efficiency in agricultural production by developing solutions specific to our customers\' needs.',
      content3: 'Our team, which closely follows technological developments, contributes to the protection of natural resources by supporting environmentally friendly and sustainable agricultural practices.'
    },
    timeline: {
      title: 'Our History',
      subtitle: 'Important milestones in our 20-year journey',
      items: {
        2005: { title: 'Foundation', desc: 'GüvenTar Systems was established' },
        2007: { title: 'First 50 Projects', desc: 'Successfully completed 50th project' },
        2010: { title: 'First 100 Projects', desc: 'Successfully completed 100th project' },
        2015: { title: 'Technology Investment', desc: 'Modern automation systems' },
        2020: { title: 'Regional Expansion', desc: 'Service throughout Turkey' },
        2024: { title: 'Sustainability', desc: '500+ completed projects' }
      }
    },
    vision: {
      title: 'Vision & Mission',
      vision: {
        title: 'Our Vision',
        desc: 'To be the leading company in agricultural irrigation technologies in Turkey and to spread sustainable agricultural practices.'
      },
      mission: {
        title: 'Our Mission',
        desc: 'To increase the profitability of our farmers by increasing water efficiency in agricultural production and to protect natural resources.'
      }
    },
    coreValues: {
      title: 'Our Values',
      subtitle: 'Our fundamental values that determine our way of doing business are the foundation of the strong relationships we establish with our customers.',
      trust: {
        title: 'Trust',
        desc: 'The trust relationship we establish with our customers is the cornerstone of our business. Keeping our word and providing quality service is our priority.'
      },
      quality: {
        title: 'Quality',
        desc: 'We apply the highest quality standards in every stage from the materials we use to the service we provide.'
      },
      satisfaction: {
        title: 'Customer Satisfaction',
        desc: 'Understanding our customers\' needs and providing solutions that exceed their expectations is our basic approach.'
      },
      nature: {
        title: 'Nature Friendly',
        desc: 'It is our responsibility to protect natural resources using environmentally friendly technologies and leave a livable world to future generations.'
      }
    },
    team: {
      title: 'Our Expert Team',
      subtitle: 'Our experienced team consisting of engineers and technicians specialized in their fields',
      engineering: {
        title: 'Engineering Team',
        desc: 'Irrigation systems design and project specialists'
      },
      technical: {
        title: 'Technical Team',
        desc: 'System installation and maintenance specialists'
      },
      consulting: {
        title: 'Consulting Team',
        desc: 'Customer relations and project consulting specialists'
      }
    }
  },
  products: {
    hero: {
      title: 'Our Products',
      subtitle: 'Quality agricultural irrigation solutions and modern technology products'
    },
    categories: {
      title: 'Product Categories',
      all: 'All Products',
      drip: 'Drip Irrigation',
      sprinkler: 'Sprinkler',
      micro: 'Micro Sprinkler',
      automation: 'Automatic Control',
      filter: 'Filter Systems',
      fertilizer: 'Fertilizer Mixing'
    },
    modal: {
      features: 'Features',
      specs: 'Technical Specifications',
      usage: 'Usage Areas',
      viewPdf: 'View Products (PDF Catalog)',
      whatsapp: 'WhatsApp Contact',
      getQuote: 'Get Quote',
      freeInspection: 'Free Inspection'
    }
  },
  contact: {
    hero: {
      title: 'Get in Touch',
      subtitle: 'Contact our expert team, let\'s develop a custom irrigation solution for you'
    },
    info: {
      title: 'Contact Information',
      address: {
        title: 'Address'
      },
      phone: {
        title: 'Phone'
      },
      email: {
        title: 'Email'
      },
      hours: {
        title: 'Working Hours',
        weekdays: 'Monday - Saturday: 08:00 - 18:00',
        weekend: 'Sunday: Closed'
      }
    },
    whatsapp: {
      title: 'WhatsApp Contact',
      desc: 'Contact us via WhatsApp for quick support',
      button: 'Send WhatsApp Message'
    },
    form: {
      title: 'Send Message',
      name: 'Full Name',
      'name.placeholder': 'Enter your name and surname',
      phone: 'Phone',
      'phone.placeholder': 'Enter your phone number',
      email: 'Email',
      'email.placeholder': 'Enter your email address',
      subject: 'Subject',
      'subject.placeholder': 'Select a subject',
      'subject.drip': 'Drip Irrigation Systems',
      'subject.sprinkler': 'Sprinkler Systems',
      'subject.automation': 'Automation Systems',
      'subject.maintenance': 'Maintenance and Repair',
      'subject.other': 'Other',
      message: 'Message',
      'message.placeholder': 'Write your message...',
      'message.limit': 'characters',
      submit: 'Send Message'
    },
    map: {
      title: 'Location'
    }
  }
};